import React from "react";
import { ButtonSpan } from "../../../../../Components/Button";
import { useSelector } from "react-redux";
import moment from "moment";
import { commercialDeals } from "../../../../../redux/reducers/commercial-deals";
import { saveData } from "../../../../../services/downloadFile";
import axios from "axios";
let CommercialDealEventInformation = ({ commercialDeal }) => {
  const token = useSelector(state => state.auth.token);
  if (!commercialDeal) {
    return <></>;
  }
  async function handleDownload(type, url, name) {
    try {
      const response = await axios.get(url, {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      saveData(type, response.data, name);
    } catch (err) {
      alert("Sorry there was a problem fetching the file");
    }
  }

  return (
    <div className="p-3 text-black my-2">
      <p>
        <span className="font-bold text-lg">{commercialDeal.name}</span>
      </p>
      <p>
        <span>
          Between{" "}
          {commercialDeal.agencyName
            ? commercialDeal.agencyName + " - "
            : commercialDeal.companyName
            ? commercialDeal.companyName + " - "
            : ""}
          {commercialDeal.group ? commercialDeal.group.name : ""}
        </span>
      </p>
      <p>
        <span className={"mr-5"}>
          Commission Percentage:
          <span className="font-bold">
            {" "}
            {commercialDeal.default_event_commission_percentage + "%"}
          </span>
        </span>{" "}
        <span className={"mr-5"}>
          Applied On:
          <span className="font-bold">
            {" "}
            {commercialDeal.commission_applied_on}
          </span>
        </span>
        <span className={"mr-5"}>
          Includes Tax:{" "}
          <span className="font-bold">
            {" "}
            {commercialDeal.commission_vat_inclusive ? "Yes" : "No"}
          </span>
        </span>
      </p>
      {commercialDeal.document_file ? (
        <div className={"flex justify-end items-center py-1"}>
          <span className="font-bold text-xl">
            <ButtonSpan
              className="text-base font-normal underline ml-2"
              onClick={() =>
                handleDownload(
                  commercialDeal.document_file_mime_type,
                  commercialDeal.url,
                  commercialDeal.document_filename
                )
              }
            >
              Download Details
            </ButtonSpan>
          </span>
        </div>
      ) : null}
    </div>
  );
};

export default CommercialDealEventInformation;
